document.addEventListener("DOMContentLoaded", function(event) {
    const newsListingAccordions = document.getElementsByClassName(
        "news-listing-accordions"
    );
    const searchAccordions = document.getElementsByClassName(
        "search-accordions"
    );
    if (newsListingAccordions.length) {
        newsListingAccordions[0].children[0].children[0].click();
    }
    if (searchAccordions.length) {
        searchAccordions[0].children[0].children[0].click();
    }
});
